import { Col, Flex, Image, Modal, Row, Tag, Typography, Upload } from "antd";
import React, { useEffect } from "react";
import { CustomTitle } from "../../../../../common/customTitle";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getServiceProviderAppointmentsInfoByIdAction } from "../../../../../../redux/services/service-provider-appointments/serviceProviderAppointmentsServices";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import {
  dateObjToDispViewDate,
  downloadUrl,
  formulateAttachmentPreview,
  readImageFileAsync,
  timeObjToDispViewTimeWithSuffix,
} from "../../../../../../utils/utils";
import dayjs from "dayjs";
import { colors } from "../../../../../../constants/colors";
import Spinner from "../../../../../common/spinner/Spinner";
import Actions from "../../../../../../redux/actions";
import Title from "antd/es/typography/Title";

const AppointmentDetailsDialog = ({ open, onClose }) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const { selectedCalendarAppointment } = useSelector(
    (state) => state.serviceProviderAppointments
  );
  /* id dependencies */

  /* detail dependencies */
  const [appointmentsInfoDetails, setAppointmentsInfoDetails] = useState(null);
  const [tempAppointmentsInfoDetails, setTempAppointmentsInfoDetails] =
    useState(null);
  /* detail dependencies */

  /* module dependencies for attachment */
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [attachmentList, setAttachmentList] = useState([]);
  const [servicesAttachmentList, setServicesAttachmentList] = useState([]);
  /* module dependencies for attachment */

  const handleDialogClose = () => {
    onClose();
    dispatch(
      Actions.createAction(Actions.SELECTED_CALENDAR_APPOINTMENT_ID, {
        selectedCalendarAppointment: {
          selectedCalendarAppointmentId: "",
          service_id: "",
          order_type: "",
        },
      })
    );
    setAppointmentsInfoDetails(null);
    setServicesAttachmentList([]);
    setAttachmentList([]);
  };

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedCalendarAppointment?.selectedCalendarAppointmentId &&
      selectedCalendarAppointment?.selectedCalendarAppointmentId !== "" &&
      selectedCalendarAppointment?.selectedCalendarAppointmentId !== null &&
      selectedCalendarAppointment?.selectedCalendarAppointmentId !== undefined
    ) {
      const dataToBeSent = {
        selectedAppointmentsInfoId:
          selectedCalendarAppointment?.selectedCalendarAppointmentId,
      };
      dispatch(
        getServiceProviderAppointmentsInfoByIdAction(dataToBeSent, setLoading)
      ).then((apiRes) => {
        const response = apiRes;
        setAppointmentsInfoDetails(response);

        let tempAppointmentDetails = response;
        if (response?.order_type === "package") {
          const packageSingleService = response?.services?.find(
            (element) =>
              element?.service_id._id ===
              selectedCalendarAppointment?.service_id
          );
          tempAppointmentDetails = packageSingleService;
        }
        setTempAppointmentsInfoDetails(tempAppointmentDetails);
        setAttachmentList(
          response?.documents
            ?.map((element) => ({
              ...element,
              url: element?.url !== "" ? element?.url : null,
            }))
            .filter((element) => element?.url !== null)
        );
        setServicesAttachmentList(
          response?.service_id?.images?.map((element) => ({
            ...element,
            url: element?.url,
          }))
        );
      });
    }
  }, [open]);

  /* open image preview for dialog - multiple attachment */
  const handleAttachmentPreview = async (file) => {
    const formulateAttachment = await formulateAttachmentPreview(
      file,
      file?.name,
      file.url
    );
    if (!formulateAttachment?.isFileTypeImage) {
      downloadUrl(formulateAttachment?.fileImagePreview);
    } else {
      if (!file.url && !file.preview) {
        file.preview = await readImageFileAsync(file.originFileObj);
      }
      setPreviewImageSrc(file?.url || file?.preview);
      setOpenPreviewDialog(true);
      const tempPreviewTitle =
        file?.name || file?.url?.substring(file?.url?.lastIndexOf("/") + 1);
      setPreviewTitle(tempPreviewTitle);
    }
  };
  /* open image preview for dialog - multiple attachment */

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      width={800}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("Modules.Appointments.appointmentDetails")}
        </CustomTitle>
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Flex vertical gap="2rem">
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.profileImage")}
                    required={false}
                  />
                  {appointmentsInfoDetails?.user_id?.profile_image ? (
                    <Image
                      style={{
                        width: "120px",
                        maxWidth: "100%",
                        border: "1px solid lightGray",
                        padding: "5px",
                        borderRadius: "10px",
                      }}
                      src={
                        appointmentsInfoDetails?.user_id?.profile_image ?? "-"
                      }
                      alt={t("Modules.Appointments.profileImage")}
                    />
                  ) : (
                    <>-</>
                  )}
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.customerName")}
                    required={false}
                  />
                  <div>
                    {appointmentsInfoDetails?.user_id
                      ? `${appointmentsInfoDetails?.user_id?.first_name} ${appointmentsInfoDetails?.user_id?.last_name}`
                      : "-"}
                  </div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.customerEmail")}
                    required={false}
                  />
                  <div>
                    {appointmentsInfoDetails?.user_id
                      ? appointmentsInfoDetails?.user_id?.email
                      : "-"}
                  </div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("CommonUtils.service")}
                    required={false}
                  />
                  <div>
                    {appointmentsInfoDetails?.service_id
                      ? appointmentsInfoDetails?.service_id?.title
                      : tempAppointmentsInfoDetails?.service_name}
                  </div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("CommonUtils.staffName")}
                    required={false}
                  />
                  <div>
                    {appointmentsInfoDetails?.service_provider_id
                      ? `${appointmentsInfoDetails?.service_provider_id?.first_name} ${appointmentsInfoDetails?.service_provider_id?.last_name}`
                      : "-"}
                  </div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.appointmentTime")}
                    required={false}
                  />
                  <div>
                    {/* {timeObjToDispViewTimeWithSuffix(
                      dayjs(tempAppointmentsInfoDetails?.appointment_date_time)
                        .subtract(
                          dayjs(
                            tempAppointmentsInfoDetails?.appointment_date_time
                          ).utcOffset(),
                          "minute"
                        )
                        .format("YYYY-MM-DDTHH:mm:ss")
                    )} */}
                    {timeObjToDispViewTimeWithSuffix(dayjs(tempAppointmentsInfoDetails?.appointment_date_time).utc().local().format('ddd, MMM D, H:mm z')) || ""}
                  </div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.appointmentDate")}
                    required={false}
                  />
                  <div>
                    {dateObjToDispViewDate(
                      tempAppointmentsInfoDetails?.appointment_date,
                      "ddmmyyyy"
                    )}
                  </div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.bookingFor")}
                    required={false}
                  />
                  <div>{tempAppointmentsInfoDetails?.booking_for}</div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.charges")}
                    required={false}
                  />
                  <div>{appointmentsInfoDetails?.total_amount?.toFixed(2)}</div>
                </Col>

                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.paymentStatus")}
                    required={false}
                  />
                  <Tag
                    bordered={false}
                    style={{
                      background: appointmentsInfoDetails?.is_payment_completed
                        ? colors.lightTeal
                        : colors.lightPinkishRed,
                      color: appointmentsInfoDetails?.is_payment_completed
                        ? colors.darkTeal
                        : colors.darkMaroon,
                    }}
                  >
                    {appointmentsInfoDetails?.is_payment_completed
                      ? t("Modules.Appointments.paid")
                      : t("Modules.Appointments.due")}
                  </Tag>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.orderNumber")}
                    required={false}
                  />
                  <div>{appointmentsInfoDetails?.order_number}</div>
                </Col>

                {/* <Col span={8}>
                  <RequiredLabel
                    text={t("appointmentInfo.order_status")}
                    required={false}
                  />
                  <Tag
                  style={{
                    background:
                    tempAppointmentsInfoDetails?.status === "COMPLETED"
                        ? colors.darkSearGreen
                        : tempAppointmentsInfoDetails?.status === "REJECTED"
                        ? colors.lightPinkishRed
                        : colors.slatePurple,
                    color:
                    tempAppointmentsInfoDetails?.status === "COMPLETED"
                        ? colors.limeGreen
                        : tempAppointmentsInfoDetails?.status === "REJECTED"
                        ? colors.darkMaroon
                        : colors.indigo,
                  }}
                  bordered={false}
                >
                  {tempAppointmentsInfoDetails?.status}
                </Tag>
                </Col> */}

                <Col span={24}>
                  <RequiredLabel
                    text={t("Modules.Appointments.nationalIDDocuments")}
                    required={false}
                  />
                  {attachmentList?.length !== 0 ? (
                    <Flex vertical align="center" justify="center">
                      <Upload
                        listType="picture-card"
                        fileList={attachmentList.filter(
                          (element) => element.url !== ""
                        )}
                        accept="image/*"
                        onPreview={handleAttachmentPreview}
                        className="uploadContainer"
                      ></Upload>
                      <Modal
                        open={openPreviewDialog}
                        title={previewTitle}
                        footer={null}
                        onCancel={() => setOpenPreviewDialog(false)}
                      >
                        <img style={{ width: "100%" }} src={previewImageSrc} />
                      </Modal>
                    </Flex>
                  ) : (
                    <>-</>
                  )}
                </Col>

                {appointmentsInfoDetails?.booking_for === "other" && (
                  <Col span={24}>
                    <Flex vertical gap="1rem">
                      <Typography.Title level={3}>
                        {t("Modules.Appointments.bookingForDetails")}
                      </Typography.Title>
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <RequiredLabel
                            text={t("Modules.Appointments.name")}
                            required={false}
                          />
                          <div>{`${appointmentsInfoDetails?.booking_for_details?.first_name} ${appointmentsInfoDetails?.booking_for_details?.last_name}`}</div>
                        </Col>
                        <Col span={8}>
                          <RequiredLabel
                            text={t("Modules.Appointments.email")}
                            required={false}
                          />
                          <div>
                            {
                              appointmentsInfoDetails?.booking_for_details
                                ?.email || "-"
                            }
                          </div>
                        </Col>
                        <Col span={8}>
                          <RequiredLabel
                            text={t("Modules.Appointments.relationship")}
                            required={false}
                          />
                          <div>
                            {
                              appointmentsInfoDetails?.booking_for_details
                                ?.relationship
                            }
                          </div>
                        </Col>
                      </Row>
                    </Flex>
                  </Col>
                )}
              </Row>
            </Flex>
          </>
        )}
      </Flex>
    </Modal>
  );
};

export default AppointmentDetailsDialog;
